import { useAuthContext } from "../../../../hooks/useAuthContext";
import { useNavigate } from "react-router-dom";
import CreateOrAssociateContractModal from "../modals/CreateOrAssociateContractModal";
import { useRef } from "react";
import { Card } from "primereact/card";
import { PERMISSION_TRAINING_CONTRACTS, PERMISSION_TRAINING_REGISTRATION, PERMISSION_TRAINING_TASKS } from "../../../../permissions";
import { ToFormatedDateForEvents } from "../../../../utils/dates";
import MeaMemberAvatar from "../../../../components/MeaMemberAvatar";
import MeaButton from "../../../../components/MeaButton";
import UpdateRegistrationConfirmationDetailsModal from "../modals/UpdateRegistrationConfirmationDetailsModal";
import RegistrationStepActions from "./RegistrationStepActions";

const RegistrationStepConfirmationComponent = ({ currentStudent, setCurrentStudent, callback, schoolId, trainingId }) => {

    const { hasPermission } = useAuthContext();
    const navigate = useNavigate();

    const hasCreateContractPermission = hasPermission(PERMISSION_TRAINING_CONTRACTS.CREATE)
    const hasUpdateContractsPermission = hasPermission(PERMISSION_TRAINING_CONTRACTS.UPDATE)
    const hasGetContractPermission = hasPermission(PERMISSION_TRAINING_CONTRACTS.GET)
    const hasUpdateRegistrationsStatusPermission = hasPermission(PERMISSION_TRAINING_TASKS.UPDATE_REGISTRATIONS_STATUS)

    const createOrAssociateContractModalRef = useRef();
    const updateRegistrationConfirmationDetailsModalRef = useRef(null);
    const statusActionsRef = useRef(null);

    const headerTemplate = (options) => {
        const className = `${options.className} justify-content-space-between`;
        return (
            <div className={className}>
                <div className="flex align-items-center gap-2">
                    <i className="text-2xl pi pi-credit-card text-green-500"></i>
                    <span className="font-bold">Confirmation</span>
                </div>
                <div>
                    {options.togglerElement}
                </div>
            </div>
        );
    };

    const footerTemplate = (options) => {
        const className = `${options.className} flex flex-wrap align-items-center justify-content-between`;
        return (
            <div className={className}>
                <div className="flex align-items-center gap-2">
                </div>
                <RegistrationStepActions
                    ref={statusActionsRef}
                    currentStudent={currentStudent}
                    schoolId={schoolId}
                    trainingId={trainingId}
                    callback={callback}
                    primary={currentStudent?.contract_id ? {
                        label: "Ouvrir le contrat",
                        icon: "pi pi-credit-card",
                        severity: "success",
                        outlined: true,
                        disabled: !hasGetContractPermission,
                        onClick: () => navigate(`/school/${schoolId}/admin/registrations/${trainingId}/contracts/${currentStudent?.contract_id}`),
                    } : {
                        label: "Créer ou associer un contrat",
                        severity: "success",
                        disabled: !hasCreateContractPermission && !hasUpdateContractsPermission,
                        onClick: () => createOrAssociateContractModalRef.current.show(currentStudent, () => { callback?.() }),
                    }}
                    items={[
                        {
                            label: "Désinscrire",
                            icon: "pi pi-sign-out",
                            visible: hasUpdateRegistrationsStatusPermission,
                            command: () => statusActionsRef.current?.changeStatus("UNREGISTRED"),
                        },
                    ]}
                />
            </div>
        );
    };

    return (
        <>
            <CreateOrAssociateContractModal ref={createOrAssociateContractModalRef} schoolId={schoolId} trainingId={trainingId} />
            <UpdateRegistrationConfirmationDetailsModal ref={updateRegistrationConfirmationDetailsModalRef} student={currentStudent} schoolId={schoolId} trainingId={trainingId} />
            {(currentStudent?.status === "ENROLLED") &&
                <Card footer={footerTemplate} >
                    <ul className="list-none p-0 m-0">

                        <li className="flex align-items-center py-2 px-2 flex-wrap ">
                            <div className="text-500 w-full md:w-5 font-medium text-left md:text-right">Confirmé le</div>
                            <div className="text-900 w-full pl-3 md:w-7">{ToFormatedDateForEvents(new Date(currentStudent?.registration_confirmation_date), false)}</div>
                        </li>
                        <li className="flex align-items-center py-2 px-2 flex-wrap ">
                            <div className="text-500 w-full md:w-5 font-medium text-left md:text-right">Confirmé par</div>
                            <div className="text-900 w-full pl-3 md:w-7"><MeaMemberAvatar member={currentStudent?.registration_confirmation_by} noNavigation={false} /></div>
                        </li>
                        <li className="flex align-items-center py-2 px-2 flex-wrap ">
                            <div className="text-500 w-full md:w-5 font-medium text-left md:text-right">Détails de confirmation</div>
                            <div className="text-900 w-full pl-3 md:w-7">
                                <div className="flex justify-content-between flex-wrap align-items-center">
                                    <div className="w-10">{currentStudent?.registration_confirmation_details || "-"}</div>
                                    <div className="w-2">
                                        <MeaButton
                                            permission={PERMISSION_TRAINING_REGISTRATION.UPDATE}
                                            icon="pi pi-pencil"
                                            className="mr-2"
                                            size="small"
                                            text
                                            onClick={() => {
                                                if (updateRegistrationConfirmationDetailsModalRef.current) {
                                                    updateRegistrationConfirmationDetailsModalRef.current.show(() => {
                                                        callback?.();
                                                    });
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li className="flex align-items-center py-2 px-2 flex-wrap ">
                            <div className="text-500 w-full md:w-5 font-medium text-left md:text-right">Immatriculation</div>
                            <div className="text-900 w-full pl-3 md:w-7">{currentStudent?.member_id || "-"}</div>
                        </li>
                        <li className="flex align-items-center py-2 px-2 flex-wrap ">
                            <div className="text-500 w-full md:w-5 font-medium text-left md:text-right">Contrat</div>
                            <div className="text-900 w-full pl-3 md:w-7">
                                {currentStudent?.contract_id || "-"}
                            </div>
                        </li>
                    </ul>
                </Card>}
        </>
    );
}

export default RegistrationStepConfirmationComponent;